/** @jsxImportSource @emotion/react */

import React from 'react';
import { useTheme } from '@emotion/react';
import { animated, useSpring } from 'react-spring';
import { data } from '../Data/index';

type JingleBellProps = {
  rotation?: number;
  timing?: number;
};

export const JingleBell = ({ rotation = 15, timing = 100 }: JingleBellProps) => {
  const theme = useTheme();
  const [isJingled, setIsJingled] = React.useState(false);
  const style = useSpring({
    display: 'inline-block',
    height: '22px',
    transform: isJingled ? `rotate(${rotation}deg)` : `rotate(0deg)`,
    transformOrigin: '11px 0',
    config: {
      tension: 800,
      friction: 10
    }
  });

  React.useEffect(() => {
    if (!isJingled) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsJingled(false);
    }, timing);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isJingled, timing]);
  const trigger = () => {
    setIsJingled(true);
  };

  return (
    <div
      css={{
        alignItems: 'center',
        background: theme.color.greyLight,
        boxSizing: 'border-box',
        display: 'flex',
        padding: '0.5rem 1rem',
        marginBottom: '1.5rem',
        width: '100%'
      }}
      onMouseEnter={trigger}
    >
      <div
        css={{
          alignItems: 'center',
          display: 'flex'
        }}
      >
        <animated.span style={style}>
          <svg id="bell" width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11 21.542a2.753 2.753 0 002.709-2.292H8.29A2.753 2.753 0 0011 21.542zM20.081 17.609c-.022-.031-2.206-3.126-2.206-5.692V7.333a6.875 6.875 0 10-13.75 0v4.584c0 2.566-2.184 5.661-2.206 5.692a.458.458 0 00.373.724h17.416a.459.459 0 00.373-.724z"
              fill="#E43896"
            />
          </svg>
        </animated.span>
      </div>
      <p css={{ margin: '0 0 0 0.5rem' }} dangerouslySetInnerHTML={{ __html: data.dictionary.tip }}></p>
    </div>
  );
};
